export enum PayoutStatus {
  InReview,
  Done,
  Rejected,
  ReadyForPayment,
  Processing,
}
